/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  makeStyles,
  Grid,
  Paper,
  Button,
  Typography,
  IconButton,
} from '@material-ui/core';
import 'date-fns';
import TextField from '@material-ui/core/TextField';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import PFPBox from './PFPBox';
import DSPBreadCrums from './DSPCreation/DSPBreadCrums';

const useStyles = makeStyles((theme) => ({
  DSPCard: {
    width: "90%",
    paddingLeft: '5%',
    paddingRight: '5%',
    paddingTop: '16px',
    paddingBottom: '16px',
    marginBottom: '3%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '10px',
  },
  root: {
    margin: '0 auto',
    display: 'block',
    height: 'unset',
  },
  titleText: {
    color: '#0046AD',
    
    fontWeight: 'bold',
    fontFamily: 'Arial',
    marginTop: '10px',
    marginBottom: '10px',
    [theme.breakpoints.down('sm')]: {
     
    },
  },
  cardTitle: {
    color: '#000000',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    fontFamily: 'Arial',
    marginTop: '10px',
    marginBottom: '20px',
    [theme.breakpoints.up('md')]: {
      alignSelf: 'flex-start',
      fontSize: '1.3rem',
    },
  },
  input: {
    width: '100%',
    marginTop: '2%',
    marginBottom: '2%',
    '& .Mui-disabled': {
      backgroundColor: '#F0F0F0',
      color: '#000000',
    },
    '& .MuiFormLabel-root': {
      paddingRight: '14px',
      backgroundColor: 'transparent',
    },
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      '& .MuiSelect-root': {
        fontSize: '14px',
      },
      '& .MuiFormLabel-root': {
        fontSize: '14px',
      },
      '& .MuiInputBase-input': {
        fontSize: '14px',
      },
    },
  },
  creatorsInfoInput: {
    width: '85%',
    marginTop: '2%',
    marginBottom: '2%',
    '& .Mui-disabled': {
      backgroundColor: '#F0F0F0',
      color: '#000000'
    },
    '& .MuiFormLabel-root': {
      paddingRight: '14px',
      backgroundColor: 'transparent',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      marginRight: '10px',
      '& .MuiSelect-root': {
        fontSize: '14px',
      },
      '& .MuiFormLabel-root': {
        fontSize: '14px',
      },
      '& .MuiInputBase-input': {
        fontSize: '14px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: '5px',
    },
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  buttonContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down('sm')]: {
      flexDirection: "column-reverse",
    }
  },
  backButtonGrid: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      justifyContent: 'center',
    },
  },
  saveButtonGrid: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      justifyContent: 'center',
    },
  },
  backButton: {
    borderRadius: '8px',
    borderWidth: '2px',
    width: '160px',
    borderColor: "#0046AD",
    marginBottom: '10px',
    color: "#0046AD",
    fontSize: '18px',
    fontFamily: 'Arial',
    fontWeight: 'bold',
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      width: '70%',
    },
  },
  saveButton: {
    borderRadius: '8px',
    width: '160px',
    backgroundColor: '#0046AD',
    marginBottom: '10px',
    color: "#FFFFFF",
    fontSize: '18px',
    fontFamily: 'Arial',
    fontWeight: 'bold',
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      width: '70%',
    },
    '&:disabled': {
      background: 'gray',
      color: '#FFFFFF',
    }
  },
  addRemoveButton: {
    color: "#FFFFFF",
    backgroundColor: "#009B74",
    borderRadius: 8,
    height: '60%',
    padding: '8px',
    [theme.breakpoints.down('sm')]: {
      padding: '5px',
    },
  },
  summaryText: {
    fontSize: '16px',
    color: '#000000',
    fontWeight: 'normal',
  },
  summaryTextBold: {
    fontSize: '16px',
    color: '#0046AD',
    fontWeight: 'bold'
  },
}));

function DSPCover(props: any): JSX.Element {
  const defaultAvatar="data:image/png;base64,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";
  const classes = useStyles();

  const { setSession } = props;
  const [editable, setEditable] = useState(true);
  const [childName, setChildName] = useState("");
  const [profilePicture, setProfilePicture] = useState(defaultAvatar);
  const [dateOfBirth, setDateOfBirth] = useState<Date | null>(null);
  const [additionalInformation, setAdditionalInformation] = useState("");

  const [creationDate, setCreationDate] = useState<Date>(new Date());
  const [creatorList, setCreatorList] = useState([""]);

  useEffect(() => {
    if(sessionStorage.getItem('coverPage') && sessionStorage.getItem('coverPage') === 'completed'){
      setChildName(sessionStorage.getItem('childName') as string);
      setProfilePicture(sessionStorage.getItem('childProfilePicture')as string);
      setDateOfBirth(new Date(sessionStorage.getItem('childDOB') as string))
      setAdditionalInformation( sessionStorage.getItem('childAdditionalInformation') as string)

      setCreationDate(new Date(sessionStorage.getItem('creationDate')?.substring(4) as string))

      setCreatorList(sessionStorage.getItem('creatorList')?.split(';')!)
    }
  }, [])

  const toggleEditMode = (event: any) => {
    setEditable(!editable);
  }

  const handleBack = (event: any) => {
    //if(window.confirm('Are you sure you want to leave? Save your DSP locally to keep your progress.')){
    setSession('main');
    //}
  }


  const handleSubmit = (event: any) => {
    event.preventDefault();
    sessionStorage.setItem('childName', childName);
    if(!profilePicture)
      sessionStorage.setItem('childProfilePicture', defaultAvatar);
    else
      sessionStorage.setItem('childProfilePicture', profilePicture);
    sessionStorage.setItem('childDOB', dateOfBirth ? dateOfBirth.toDateString() : "");
    sessionStorage.setItem('childAdditionalInformation', additionalInformation);
    sessionStorage.setItem('creationDate', creationDate ? creationDate.toDateString(): "");
    sessionStorage.setItem('creatorList', creatorList.join(';'));
    sessionStorage.setItem('coverPage', 'completed');
    props.setSession('main')
  }

  const renderSummaryCard = () => {

    const getAge = () => {
      if (!dateOfBirth) {
        // should never happen
        return "N/A years";
      }

      const currentDate = new Date();

      const difMonths=currentDate.getMonth() -dateOfBirth.getMonth() +12 * (currentDate.getFullYear() - dateOfBirth.getFullYear());

      if(difMonths>12){
        const years:number=(difMonths/12)|0;
        const months:number=difMonths%12;
        return `${years} year(s) ${months} month(s)`;
      }else{
        return `${difMonths} month(s)`;
      }
     
    }

    const getDate = () => {
      const options = { year: 'numeric', month: 'long', day: 'numeric' } as const;
      return creationDate.toLocaleDateString("en-US", options);
    }

    const getCreatorsText = () => {
      if (creatorList.length === 1) {
        return (
          <span className={classes.summaryTextBold}>{creatorList[0]}</span>
        )
      }
      if (creatorList.length === 2) {
        // const and = <span className={classes.summaryText}> and </span>;
        return (
          <span className={classes.summaryTextBold}>{creatorList[0]}<span className={classes.summaryText}> and </span>{creatorList[1]}</span>
        )
      }
      if (creatorList.length === 2) {
        return (
          <span className={classes.summaryTextBold}>{creatorList[0]}<span className={classes.summaryText}>, </span>{creatorList[1]}<span className={classes.summaryText}> and </span>{creatorList[2]}</span>
        )
      }

      // TODO: Should turn the above into a loop if we ever allow > 3 creators
      return creatorList.join(', ');
    }

    const nameText = <span className={classes.summaryTextBold}>{childName}</span>;
    const ageText = <span className={classes.summaryTextBold}>{getAge()}</span>;
    const dateText = <span className={classes.summaryTextBold}>{getDate()}</span>;
    sessionStorage.setItem('age',getAge());
      return (
      <Paper elevation={0} className={classes.DSPCard} style={{ alignItems: 'flex-start' }}>
        <Typography className={classes.summaryText}>
          This plan was created for {nameText} aged {ageText} on {dateText} by {getCreatorsText()}.
        </Typography>
      </Paper>
    )
  }

  return (

    <Grid container item xs={11} className={classes.root}>

      <DSPBreadCrums
        setSession={props.setSession}
        session={props.session}
        setExpandMenu={props.setExpandMenu}
        items={[
          { name: 'Create New Plan', link: 'main' },
          { name: 'Cover Page', link: 'coverPage' },
        ]}
      />

      {editable &&
        <Typography
          variant="h4" className={classes.titleText}>
          Cover Page
        </Typography>
      }

      

      <ChildsInformationCard
        childName={childName} setChildName={setChildName}
        profilePicture={profilePicture} setProfilePicture={setProfilePicture}
        dateOfBirth={dateOfBirth} setDateOfBirth={setDateOfBirth}
        additionalInformation={additionalInformation} setAdditionalInformation={setAdditionalInformation}
        disableInputs={!editable}
      />

      <CreatorsInformationCard
        creationDate={creationDate} setCreationDate={setCreationDate}
        creatorList={creatorList} setCreatorList={setCreatorList}
        disableInputs={!editable}
      />
      {!editable && renderSummaryCard()}
      <Grid container className={classes.buttonContainer}>
        <Grid item xs={12} md={6} className={classes.backButtonGrid}>
          {editable ?

            <Button variant='outlined' className={classes.backButton} onClick={handleBack}>
              Back
            </Button>

            :
            <Button variant='outlined' className={classes.backButton} onClick={toggleEditMode}>
              Edit
            </Button>


          }
        </Grid>

        <Grid item xs={12} md={6} className={classes.saveButtonGrid} >
          {editable ?
            <Button variant='contained' className={classes.saveButton} onClick={toggleEditMode}
              disabled={!childName || !dateOfBirth || creatorList.includes("") || !creationDate}>
              Save
            </Button>
            :
            <Button variant='contained' className={classes.saveButton} onClick={handleSubmit} style={{backgroundColor: '#0046AD'}}>
              Submit
            </Button>
          }
        </Grid>
      </Grid>
    </Grid>
  );
}

function ChildsInformationCard(props: any) {
  const classes = useStyles();
  const { childName, setChildName, profilePicture, setProfilePicture, dateOfBirth, setDateOfBirth, additionalInformation, setAdditionalInformation, disableInputs } = props;
  const [open, setOpen] = useState(false);

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let name=event.target.value.replace(/[^\w\s]/, '');
    name=name.replace(/[0-9]/, '');
    setChildName(name);
    //setChildName(event.target.value.replace(/[0-9]/, ''));
  };

  const handleDOBChange = (date: Date | null) => {
    setDateOfBirth(date);
  };

  const handleAdditionalInformationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAdditionalInformation(event.target.value);
  };

  const handlePFPUpload = (file: any) => {
    setProfilePicture(file);
  }

  return (
    <Paper elevation={0} className={classes.DSPCard}>

      <Typography
        variant="h4" className={classes.cardTitle}>
        Child's Information
      </Typography>

      <Grid container className={classes.cardContainer}>
        <Grid item xs={12} md={6} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <PFPBox handleUpload={handlePFPUpload} disabled={disableInputs} defaultImage={profilePicture}/>
        </Grid>
        <Grid item xs={12} md={6} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <TextField className={classes.input} required label="Child's Name" variant="outlined" disabled={disableInputs}
            value={childName} onChange={handleNameChange} />

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              open={open}
              className={classes.input}
              disableFuture
              required
              format="MM/dd/yyyy"
              value={dateOfBirth}
              onChange={handleDOBChange}
              onClick={() => setOpen(true)}
              onClose={() => setOpen(false)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              label="Date of Birth"
              inputVariant="outlined"
              placeholder='MM/dd/yyyy'
              disabled={disableInputs}
              keyboardIcon={disableInputs ? <></> : <CalendarTodayOutlinedIcon />}
            />
          </MuiPickersUtilsProvider>
        </Grid>

        <Grid item xs={12} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <TextField
            className={classes.input}
            label="Child's Additional Information (Optional)"
            multiline
            rows={3}
            variant="outlined"
            fullWidth
            value={additionalInformation}
            onChange={handleAdditionalInformationChange}
            disabled={disableInputs}
          />

        </Grid>
      </Grid>
    </Paper>
  )
}

function CreatorsInformationCard(props: any) {
  const classes = useStyles();
  const { creationDate, setCreationDate, creatorList, setCreatorList, disableInputs } = props;


  const handleCreationDateChange = (date: Date | null) => {
    setCreationDate(date);
  };

  const renderCreatorList = () => {

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number) => {
      const list = [...creatorList];
      list[index] = event.target.value;
      setCreatorList(list);
    }

    const handleAdd = () => {
      if(creatorList.length < 3 )
        setCreatorList([...creatorList, ""])
    }

    const handleRemove = (index: number) => {
      const list = [...creatorList];
      list.splice(index, 1);
      setCreatorList(list);
    }

    return (
      creatorList.map((creator: string, index: number) => {
   
        return (
          <div key={index} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
            <TextField value={creatorList[index]} className={classes.creatorsInfoInput} required label="Plan Creator" variant="outlined" disabled={disableInputs}
              onChange={e => handleChange(e, index)} />

            {(index!=0) &&
              <IconButton aria-label="remove creator" className={classes.addRemoveButton} size="medium"
              onClick={() => handleRemove(index)}>
              <RemoveIcon />
              
            </IconButton>          
          }
            
            {(!disableInputs&& index ==0) &&
              <IconButton aria-label="add creator" className={classes.addRemoveButton} size="medium"
              onClick={handleAdd}>
              <AddIcon />
              
            </IconButton>
            }
            
          </div>
        )
      })
    )
  }

  return (
    <Paper elevation={0} className={classes.DSPCard}>
      <Typography
        variant="h4" className={classes.cardTitle}>
        Creator's Information
      </Typography>

      <Grid container className={classes.cardContainer}>
        <Grid item xs={12} md={6} style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", maxWidth: '80%' }}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>

            <KeyboardDatePicker
              className={classes.creatorsInfoInput}
              disableFuture
              required
              format="MMM/dd/yyyy"
              value={creationDate}
              onChange={handleCreationDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              label="Creation Date"
              inputVariant="outlined"
              placeholder='MMM/dd/yyyy'
              disabled={disableInputs}
              keyboardIcon={disableInputs ? <></> : <CalendarTodayOutlinedIcon />}
            />
          </MuiPickersUtilsProvider>
        </Grid>

        <Grid item xs={12} md={6} style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", maxWidth: '80%' }}>
          {renderCreatorList()}
        </Grid>
      </Grid>
    </Paper>
  )
}


export default DSPCover;